// Écran de gestion des clients (racine 411).
import React from "react";
import TiersManager from "@/components/TiersManager";

export default function Clients() {
  return <TiersManager type="client" titre="Clients" libelleSingulier="client" />;
}
